import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const SunSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default SunSVG;
